import {
    Category, Classification,
    Facet, FacetValue,
    Feature,
    FeatureValue,
    Occ,
    PaginationModel,
    Price,
    Product,
    ProductSearchPage,
    Stock
} from '@spartacus/core';

import {FacetList, SearchBoxConfig, SearchResults} from '@spartacus/storefront';

import {AimoGTMProductAttributes, GTMCartType} from '../service/gtm/aimo-gtm.model';

import Country = Occ.Country;
import CategoryHierarchy = Occ.CategoryHierarchy;

export interface AimoProduct extends Product {
    pk?: number;
    customerProductId?: string;
    contractNumber?: string;
    lowestPriceInComparison?: boolean;
    favorite?: boolean;
    novelty?: boolean;
    campaign?: boolean;
    sponsored?: boolean;
    price?: AimoPrice;
    stock?: AimoStock;
    classifications?: AimoClassification[];
    baseUnit?: AimoUnitOfMeasure;
    keyIngredients?: string;
    manualKeyIngredients?: string;
    storageInstructions?: string;
    safetyData?: SafetyData[];
    preparationInstructions?: string;
    disposalInformations?: string;
    usageInstructions?: string;
    countriesOfOrigin?: Country[];
    unitConversions?: AimoUnitConversions[];
    unit?: AimoUnitOfMeasure;
    comparisonPrice?: AimoPrice;
    comparisonUnit?: AimoUnitOfMeasure;
    lotSizeInfo?: string;
    priceWithTax?: AimoPrice;
    taxPercentage?: number;
    strikeThroughPrice?: AimoPrice;
    vendor?: AimoVendor;
    lastPurchased?: string;
    inOrderTemplate?: boolean;
    ean?: string;
    icons?: string[];
    frozenProduct?: boolean;
    allowedLotSize?: number;
    sizeInBaseUnits?: number;
    myAssortment?: boolean;
    similarProducts?: boolean;
    discount?: AimoPrice;
    pikatukkuStock?: AimoStock[];
    pikatukkuWebShopProduct?: boolean;
    nutritionalContentBasisQuantityUnit?: AimoUnitOfMeasure;
    nutritionalContentBasisQuantity?: string;
    tempQuantity?: number; //used only to store qty for ui purposes
    fishingInformation?: FishingInformation[];
    gtmProductAttributes?: AimoGTMProductAttributes;
    availabilityNotificationActive?: boolean;
    solrDebugInfo?: string;
}

export interface SafetyData {
    sheetId: string;
    statements: SafetyDataStatement[];
}

export interface SafetyDataStatement {
    code: string;
    name: string;
}

export interface FishingInformation {
    species: string;
    speciesLatinName: string;
    catchInformation: CatchInformation[];
}

export interface CatchInformation {
    catchMethod: string;
    catchArea: string;
    productionMethod: string;
}

export interface AimoProductSearchPage extends ProductSearchPage {
    suggestiveMode?: boolean;
    requestedDate?: string;
    fromCartSearch?: boolean;
    pagination?: AimoPaginationModel;
}

export interface AimoPaginationModel extends PaginationModel {
    resetSearch?: boolean;
    fullAssortmentTotalResults: number;
}

export interface AimoSearchResults extends SearchResults {
    products?: AimoProduct[];
    pagination?: AimoPaginationModel;
    keywordRedirectUrl?: string;
}

export interface AimoSearchBoxConfig extends SearchBoxConfig {
    page?: number;
    suggestiveMode?: boolean;
    lastFocusedElementId?: string;
    origin?: GTMCartType;
    fromCartSearch?: boolean;
}

export interface AimoVendor {
    code?: string;
    name?: string;
    vendorProductCode?: string;
}

export interface AimoUnitConversions {
    conversionToBaseUnit?: number;
    unit?: AimoUnitOfMeasure;
    ean?: string;
}

export interface AimoClassification extends Classification {
    features?: AimoFeature[];
}

export interface AimoFeature extends Feature {
    featureValues?: AimoFeatureValue[];
    position?: number;
}

export interface AimoFeatureValue extends FeatureValue {
    name?: string;
    unit?: AimoUnitOfMeasure;
}

export interface AimoUnitOfMeasure {
    code?: string;
    name?: string;
}

export interface AimoStock extends Stock {
    closingTime?: string;
    closingTimeForTheFuture?: string;
    availableDate?: string;
    futureStockLevel?: number;
    text?: string;
    terminalProduct?: boolean;
    salesBlockStart?: string;
    salesBlockEnd?: string;
    warehouse?: AimoWarehouse;
    unit?: AimoUnitOfMeasure;
    salesBlockedFromNowUntilForever?: boolean;
}

export interface AimoWarehouse {
    code: string;
    name: string;
}

export interface AimoPrice extends Price {
}

export interface AimoFacet extends Facet {
    code?: string;
    range?: boolean;
    expanded?: boolean;
    search?: boolean;
    type?: string;
    values?: AimoFacetValue[];
}

export interface AimoFacetValue extends FacetValue {
    code?: string;
    rangeMin?: number;
    rangeMax?: number;
    facetCode?: string;
    value?: undefined;
}

export interface AimoTemplateFacet extends AimoSelectedFacetValue {
    values?: AimoTemplateFacetValue[];
}

export interface AimoTemplateFacetValue extends AimoSelectedFacetValue {
    quantity?: number;
}

export interface AimoSelectedFacetValue extends AimoFacetValue {
    selected?: boolean;
}

export interface AimoFacetList extends FacetList {
    facets: AimoFacet[];
}

export interface AimoSavedFacets {
    name?: string;
    query?: string;
}

export interface AimoCategory extends Category {
    description?: string;
    level?: number;
    dummyCategory?: boolean;
    webextendName?: string;
}

export interface AimoCategoryHierarchy extends CategoryHierarchy {
    // Category level in hierarchy, where root=0 and it's sub categories 1 and so on
    level: number;
    // Total number of product in this and all sub-categories
    totalNumber: number;
    subcategories?: AimoCategoryHierarchy[];
}

export class AimoProductLoading {
    constructor(
        public loading: boolean,
        public code: string,
    ) {
    }
}
